import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  checklistHeader: {
    description: 'Header for the checklist',
    defaultMessage: 'Your inventory has been successfully setup!',
    id: 'HVyO1N',
  },
  contentTitle: {
    description: 'Header for the checklist',
    defaultMessage: 'Seamlessly Sync Inventory Across All Your Connected Stores',
    id: 'Lq91OO',
  },
  contentInformation: {
    description: 'Information for the checklist',
    defaultMessage:
      'Inventory sync enables you to keep accurate, up-to-date inventory to avoid overselling, keep your business running smoothly, and automate your workflow.',
    id: 'YdbWAr',
  },
  tryNow: {
    description: 'Button to try Inventory Sync',
    defaultMessage: 'Try Now',
    id: 'S0b/mh',
  },
  learnMore: {
    description: 'Button to learn more about Inventory Sync',
    defaultMessage: 'Learn More',
    id: 'ZF/0fQ',
  },
  upgradePlan: {
    description: 'Button text for upgrading plan to access inventory sync',
    defaultMessage: 'Upgrade Plan',
    id: 'kjw45n',
  },
  configureNow: {
    description: 'Button text for configuring inventory sync when user has Standard/Premium plan',
    defaultMessage: 'Configure Now',
    id: 'FrrGdn',
  },
});
